function initFreeShippingDialogs() {
  document.querySelectorAll('[data-free-shipping-root]').forEach((root) => {
    const trigger = root.querySelector('[data-free-shipping-trigger]');
    const dialog = root.querySelector('dialog');

    if (!trigger || !dialog || trigger.dataset.freeShippingBound === 'true') return;

    trigger.dataset.freeShippingBound = 'true';

    trigger.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    });

    root.querySelectorAll('[data-free-shipping-close]').forEach((closeBtn) => {
      closeBtn.addEventListener('click', () => dialog.close());
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFreeShippingDialogs);
} else {
  initFreeShippingDialogs();
}

document.addEventListener('shopify:section:load', initFreeShippingDialogs);
